const FR_CUSTOM = {

}

export default FR_CUSTOM;